import { render } from "./PageE.vue?vue&type=template&id=860f2d88&scoped=true"
import script from "./PageE.vue?vue&type=script&lang=js"
export * from "./PageE.vue?vue&type=script&lang=js"

import "./PageE.vue?vue&type=style&index=0&id=860f2d88&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-860f2d88"]])

export default __exports__